<div class="container login-page">
  <div class="row justify-content-center align-items-center login-layout">

    <!-- Loading spinner (kept out of form) -->
    <div class="text-center" [hidden]="!isLoading">
      <app-loading-spinner></app-loading-spinner>
    </div>

    <!-- Login card -->
    <div
      class="card login-card"
      [hidden]="isLoading"
      [class.SmallArabicFont]="globalService.isRTL === true"
    >
      <div class="login-welcome" *ngIf="firstTime === false && agreementLink === ''">
        <div class="login-emblem"><img *ngIf="churchLogo" [src]="churchLogo" alt="" (error)="churchLogo = ''" /><i *ngIf="!churchLogo" class="fas fa-church" aria-hidden="true"></i></div>
        <p class="login-church">{{ churchName }}</p>
        <h1>{{ globalService.isRTL ? 'أهلاً بعودتك' : 'Welcome back' }}</h1>
        <p>{{ globalService.isRTL ? 'كن على تواصل مع كنيستك ومجتمعك.' : 'A place to belong. A community to grow with.' }}</p>
        <div class="login-highlights" aria-hidden="true"><i class="fas fa-calendar-alt"></i><span>{{ globalService.isRTL ? 'خدمات · مجتمع · تواصل' : 'Worship · Community · Connection' }}</span></div>
      </div>
      <div class="card-body MyCardBody rounded-bottom login-body">

        <!-- 🔑 Autofill-safe form -->
        <form
          #myForm="ngForm"
          autocomplete="on"
          role="form"
          name="loginForm"
          (ngSubmit)="onSubmit(myForm)"
        >

          <!-- LOGIN SCREEN -->
          <div [hidden]="firstTime !== false || agreementLink !== ''">

            <h2 class="login-form-title">{{ globalService.isRTL ? 'تسجيل الدخول إلى حسابك' : 'Sign in to your account' }}</h2>
            <p class="login-form-intro">{{ globalService.isRTL ? 'يسعدنا وجودك معنا.' : 'We’re glad you’re here.' }}</p>

            <div
              class="form-group row m-3"
              [class.text-right]="globalService.isRTL === true"
            >
              <label for="username">{{ globalService.isRTL ? 'البريد الإلكتروني أو رقم الهاتف' : 'Email or phone number' }}</label>
              <input
                type="text"
                inputmode="text"
                id="username"
                class="form-control text-left mb-3"
                dir="ltr"
                name="username"
                ngModel
                required
                autocomplete="username"
                placeholder="Username"
              />

              <label for="password">{{ globalService.Get("PASSWORD") }}</label>
              <input
                type="password"
                inputmode="text"
                id="password"
                class="form-control text-left"
                dir="ltr"
                name="password"
                ngModel
                required
                minlength="6"
                autocomplete="current-password"
                placeholder="Password"
              />
            </div>

            <div
              class="form-group m-3"
              [class.SmallArabicFont]="globalService.isRTL === true"
            >
              <app-user-message *ngIf="!failureClosed && error" type="error" [title]="globalService.isRTL ? 'تعذر تسجيل الدخول' : 'We couldn’t sign you in'" [message]="globalService.Get(error) || error" [dismissible]="false">
                <div messageActions class="user-message-actions"><a class="btn btn-outline-primary" [routerLink]="['/', tenantSubdomain, 'resetrequest']">{{ globalService.Get('FORGOTPASSWORD') }}</a></div>
              </app-user-message>
              <div class="row">
                <div class="col-6">
                  <button class="btn btn-primary btn-block" type="submit" [disabled]="isLogging">
                    <i *ngIf="isLogging" class="fas fa-spinner fa-spin"></i>
                    {{ globalService.Get("LOGIN") }}
                  </button>
                </div>
                <div class="col-6">
                  <a
                    class="btn btn-outline-primary btn-block"
                    routerLink="/signup"
                  >
                    {{ globalService.Get("SIGNUP") }}
                  </a>
                </div>
              </div>
            </div>

          </div>
        </form>

        <p *ngIf="emailVerification" class="text-center"><a [routerLink]="['/', tenantSubdomain, 'email-access']" [queryParams]="{returnUrl:returnUrl}">{{ globalService.isRTL ? 'تأكيد البريد أو إعادة إرسال رابط التفعيل' : 'Verify email or resend activation link' }}</a></p>
          <!-- FORGOT PASSWORD -->
        <div class="form-group text-small text-center">
          <a
            class="link pointer"
            [class.SmallArabicFont]="globalService.isRTL === true"
            [routerLink]="['/', tenantSubdomain, 'resetrequest']"
          >
            <small>{{ globalService.Get("FORGOTPASSWORD") }}</small>
          </a>
        </div>

        <!-- FIRST-TIME / AGREEMENT FLOW -->
        <div *ngIf="firstTime === false && agreementLink === ''" class="login-guest">
          <span>{{ globalService.isRTL ? 'تريد التصفح أولاً؟' : 'Just visiting?' }}</span>
          <a [routerLink]="churchHomeUrl">{{ globalService.isRTL ? 'تابع كضيف' : 'Continue as a guest' }}</a>
        </div>
        <div
          [hidden]="
            isLoading ||
            !(firstTime === true || (agreementLink && agreementLink !== ''))
          "
          [class.SmallArabicFont]="globalService.isRTL === true"
        >
          <p class="text-center text-danger welcomeHeader">
            {{ churchName }}
          </p>

          <p class="text-center text-secondary welcomeHeader">
            {{ globalService.Get("WELCOME") + ' ' + fullName }}
          </p>

          <p
            class="text-center text-secondary"
            *ngIf="agreementLink"
          >
            {{ globalService.Get("NEW_TERMS_MESSAGE") }}
          </p>

          <div class="form-group text-center mt-2">
            <div class="row">

              <div
                class="col-6"
                *ngIf="overrideMembership === 0 && firstTime"
              >
                <button
                  class="btn btn-success btn-block"
                  (click)="SetAsMembers()"
                  [disabled]="!termsAccepted && agreementLink"
                >
                  {{ globalService.Get("YES") }}
                </button>
              </div>

              <div
                class="col-6"
                *ngIf="overrideMembership === 0 && firstTime"
              >
                <button
                  class="btn btn-danger btn-block"
                  (click)="SetAsGuests()"
                  [disabled]="!termsAccepted && agreementLink"
                >
                  {{ globalService.Get("NO") }}
                </button>
              </div>

              <div
                class="col-12"
                *ngIf="overrideMembership > 0 || !firstTime"
              >
                <button
                  class="btn btn-primary btn-block"
                  (click)="Profile()"
                  [disabled]="!termsAccepted && agreementLink"
                >
                  {{ globalService.Get("PROCEED_WITH_LOGIN") }}
                </button>
              </div>

            </div>
          </div>

          <div
            class="row text-center mt-3 nomargin"
            *ngIf="agreementLink"
          >
            <div
              class="form-group col-10"
              [class.ml-4]="!globalService.isRTL"
              [class.mr-4]="globalService.isRTL"
            >
              <input
                type="checkbox"
                class="form-check-input mt-2"
                (click)="AcceptAgreement()"
              />
              <label class="form-check-label">
                {{ globalService.Get("AGREE_TO_TERMS") }}
                <a [href]="agreementLink">
                  {{ globalService.Get("CLICK_TO_REVIEW") }}
                </a>
              </label>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
